import React, { MouseEventHandler } from 'react';
import { twMerge } from 'tailwind-merge';

interface LinkProps {
    children: React.ReactNode;
    onClick: MouseEventHandler;
    className?: string;
}

const Link: React.FC<LinkProps> = ({ children, onClick, className }) => (
    <span
        role="link"
        className={twMerge(
            'text-link cursor-pointer hover:underline',
            className,
        )}
        onClick={onClick}
    >
        {children}
    </span>
);

export default Link;
